import React, { useEffect, useState } from "react";
import NavBar from "../../Component/NavBar/Navbar";
import SearchInput from "../../Component/SearchInput/searchInput";
import { DebounceInput } from "react-debounce-input";
import SortFilters from "../../Component/SortFilters/SortFilters";
import MultiSelect from "../../Component/MultiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import SkeletonLoader from "../../Component/SkeletonLoader/SkeletonLoader";
import QuestionBox from "../../Component/QuestionBox/NewQuestionBox";
import {
  getTrendingData,
  getFavouriteData,
  getTabSearchData,
} from "../../API/api";
import { handleError } from "../../utils";
import { useLocation } from "react-router-dom";
import InfiniteScroller from "../../Component/InfiniteScroll/InfiniteScroll";
import MiniDrawer from "../../Component/newNavBar/newNavBar";
import { CURRENT_ROLE } from "../../API/url";
import Switch from '@mui/material/Switch';
import { alpha, styled } from '@mui/material/styles';
import NestedSelect from "../../Component/NestedSelect/NestedSelect";

export default function CommonPage({ name }) {
  const dispatch = useDispatch();
  const currentPath = useLocation();
  const recommendState = useSelector((state) => state.recommend.isBack);
  let pageState = useSelector((state) => state[name]);
  const {
    updateAnsweredSearchedQuery,
    updateAnsweredDomainValue,
    updateAnsweredSortFilterValue,
    IsLoadingAnsweredtab,
    updateAnsweredTabData,
    updatePageNoAnswered,
    updatePageNoFavourite,
    updatePageNoSharedBy,
    updatePageNoSharedWith,
    updateFavouriteSearchedQuery,
    updateFavouriteDomainValue,
    updateFavouriteSortFilterValue,
    IsLoadingFavouritetab,
    updateFavouriteTabData,
    updateSharedBySearchedQuery,
    updateSharedByDomainValue,
    updateSharedBySortFilterValue,
    IsLoadingSharedBytab,
    updateSharedByTabData,
    updateSharedWithSearchedQuery,
    updateSharedWithDomainValue,
    updateSharedWithSortFilterValue,
    IsLoadingSharedWithtab,
    updateSharedWithTabData,
    expertAnsweredSortFilter,
    expertAnsweredCurationFilter
  } = bindActionCreators(Actions, dispatch);
  const colorCodes = JSON.parse(process.env.REACT_APP_MY_COLOR_CODE);
  const CurationSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: colorCodes['light_color_shade'],
      '&:hover': {
        backgroundColor: alpha(colorCodes['light_color_shade'], theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: colorCodes['light_color_shade'],
    },
  }));
  const [tabsearchQuery, SetTabSearchQuery] = useState(pageState.searchQuery);
  const searchBar = () => {
    return (
      <div className="trendingsearchbar">
        <SearchInput />
      </div>
    );
  };
  const isCheckRelevance = (str) => {
    let isThere = false;
    for (let i = 0; i < str.length; ++i) {
      if (str[i].label === "Relevance") {
        isThere = true;
      }
    }
    return isThere;
  };
  const filterTab = () => {
    const onChangeTabSearch = (e) => {
      updateAnsweredSearchedQuery(e.target.value);
      SetTabSearchQuery(e.target.value);
      if (e.target.value.length > 0) {
        if (!isCheckRelevance(pageState.sortOptions)) {
          let sdf = pageState.sortOptions;
          sdf.push(pageState.relevanceObj);
          if (currentPath.pathname.includes("/answered")) {
            updateAnsweredSortFilterValue(pageState.relevanceObj);
          }
          if (currentPath.pathname.includes("/favourite")) {
            updateFavouriteSortFilterValue(pageState.relevanceObj);
          }
          if (currentPath.pathname.includes("/sharedby")) {
            updateSharedBySortFilterValue(pageState.relevanceObj);
          }
          if (currentPath.pathname.includes("/sharedwith")) {
            updateSharedWithSortFilterValue(pageState.relevanceObj);
          }
        }
        SetTabSearchQuery(e.target.value);
        if (currentPath.pathname.includes("/answered")) {
          updateAnsweredSearchedQuery(e.target.value);
          updatePageNoAnswered(0);
        }
        if (currentPath.pathname.includes("/favourite")) {
          updateFavouriteSearchedQuery(e.target.value);
          updatePageNoFavourite(0);
        }
        if (currentPath.pathname.includes("/sharedby")) {
          updateSharedBySearchedQuery(e.target.value);
          updatePageNoSharedBy(0);
        }
        if (currentPath.pathname.includes("/sharedwith")) {
          updateSharedWithSearchedQuery(e.target.value);
          updatePageNoSharedWith(0);
        }
      }
      if (e.target.value.length === 0) {
        onResetTabSearch();
      }
    };
    const onChangeDomainSelect = (ad) => {
      if (currentPath.pathname.includes("/answered")) {
        updateAnsweredDomainValue(ad);
      }
      if (currentPath.pathname.includes("/favourite")) {
        updateFavouriteDomainValue(ad);
      }
      if (currentPath.pathname.includes("/sharedby")) {
        updateSharedByDomainValue(ad);
      }
      if (currentPath.pathname.includes("/sharedwith")) {
        updateSharedWithDomainValue(ad);
      }
    };

    const onChangeSortingSelect = (ad) => {
      if (pageState.sortFilter.id === ad.id) {
        return;
      }
      if (currentPath.pathname.includes("/answered")) {
        updateAnsweredSortFilterValue(ad);
      }
      if (currentPath.pathname.includes("/favourite")) {
        updateFavouriteSortFilterValue(ad);
      }
      if (currentPath.pathname.includes("/sharedby")) {
        updateSharedBySortFilterValue(ad);
      }
      if (currentPath.pathname.includes("/sharedwith")) {
        updateSharedWithSortFilterValue(ad);
      }
    };

    const onResetTabSearch = () => {
      SetTabSearchQuery("");
      if (pageState.sortFilter.label === "Relevance") {
        if (currentPath.pathname.includes("/answered")) {
          updateAnsweredSortFilterValue(pageState.sortOptions[0]);
        }
        if (currentPath.pathname.includes("/favourite")) {
          updateFavouriteSortFilterValue(pageState.sortOptions[0]);
        }
        if (currentPath.pathname.includes("/sharedby")) {
          updateSharedBySortFilterValue(pageState.sortOptions[0]);
        }
        if (currentPath.pathname.includes("/sharedwith")) {
          updateSharedWithSortFilterValue(pageState.sortOptions[0]);
        }
      }
      if (currentPath.pathname.includes("/answered")) {
        updateAnsweredSearchedQuery("");
        updatePageNoAnswered(0);
      }
      if (currentPath.pathname.includes("/favourite")) {
        updateFavouriteSearchedQuery("");
        updatePageNoFavourite(0);
      }
      if (currentPath.pathname.includes("/sharedby")) {
        updateSharedBySearchedQuery("");
        updatePageNoSharedBy(0);
      }
      if (currentPath.pathname.includes("/sharedwith")) {
        updateSharedWithSearchedQuery("");
        updatePageNoSharedWith(0);
      }
      let sdf = pageState.sortOptions;
      sdf.pop();
    };
    const onClickExpertAnsweredSortFilter = (val) =>{
      let updatedValue = val ==='desc'?'asc':'desc';
      expertAnsweredSortFilter(updatedValue);
    }
    return (
      <div className="trendingfilterbar">
        <div
          className="fiterbarInlineDisplaytrending"
          style={{ flexWrap: "wrap", width: "100%" }}
        >
          <div>
            {currentPath.pathname.includes("/answered") && (
              <span className="trendingfiltertabtitle">Answered Questions{" "}</span>
            )}
            {currentPath.pathname.includes("/favourite") && (
              <span className="trendingfiltertabtitle">Favorite Questions{" "}</span>
            )}
            {currentPath.pathname.includes("/sharedby") && (
              <span className="trendingfiltertabtitle">
                Shared Questions By Me{" "}
              </span>
            )}
            {currentPath.pathname.includes("/sharedwith") && (
              <span className="trendingfiltertabtitle">
                Shared Questions With Me{" "}
              </span>
            )}
            {!pageState.isLoading && (
              <span className="datacount px-2 py-1" >
                {pageState.totalCount}
              </span>
            )}
          </div>
          <div style={{ marginTop: "11px", display: "flex" }}>
          {currentPath.pathname.includes("/expertHome/answered")  && <>
            <span style={{marginTop:'-12px', color:'grey',cursor:'pointer', fontSize:'14px', fontWeight:'100'}}>Curation View <CurationSwitch checked={pageState.curationStatus ===""?false:true} disabled={pageState.isLoading} onChange={()=>expertAnsweredCurationFilter(pageState.curationStatus ===""?'pending':'')}   /></span>
          </>}
            <div
              style={{
                color: "grey",
                border: "1px solid lightgrey",
                marginBottom: "5px",
                marginTop: "-8px",
                backgroundColor: "#fff",
                borderRadius: "4px",
                height: "fit-content",
              }}
            >
              <div style={{ display: "flex" }}>
                &nbsp;
                <i className="fa fa-search" style={{ marginTop: "5px" }}></i>
                <DebounceInput
                  minLength={0}
                  debounceTimeout={1000}
                  value={tabsearchQuery}
                  placeholder="Search..."
                  onChange={(e) => onChangeTabSearch(e)}
                  style={{
                    height: "27px",
                    border: "none",
                    fontSize: "12px",
                    color: "grey",
                    width: "78%",
                  }}
                />
                {tabsearchQuery.length > 0 && (
                  <i
                    className="fa fa-times"
                    style={{ marginTop: "5px", cursor: "pointer" }}
                    onClick={() => onResetTabSearch()}
                  ></i>
                )}
              </div>
            </div>
            &nbsp;&nbsp;
            <span
              style={{
                fontSize: "14px",
                marginTop: "-4px",
                color: "gray",
                fontWeight: "300",
              }}
            >
              Sort by 
            </span>
            &nbsp;
            <SortFilters
              onChangeFunc={onChangeSortingSelect}
              value={pageState.sortFilter}
              options={pageState.sortOptions}
            />
           {currentPath.pathname.includes("/expertHome/answered")  && <>
            &nbsp;
            <span className={`${pageState.sortOrder==='desc'?'fa fa-sort-amount-desc':'fa fa-sort-amount-asc'}`} onClick={()=>onClickExpertAnsweredSortFilter(pageState.sortOrder)} style={{marginTop:'-2px', color:'grey',cursor:'pointer'}}></span>
            &nbsp;
           </>}
            &nbsp;
            {!currentPath.pathname.includes("/expertHome/answered")  &&<MultiSelect
              onChangeFunc={onChangeDomainSelect}
              value={pageState.domains}
              isMulti={true}
            />}
            {currentPath.pathname.includes("/expertHome/answered")  &&<NestedSelect />}
          </div>
        </div>
        <hr className="trendingtabpartition" />
      </div>
    );
  };

  const Loader = () => {
    return (
      <div className="trendingfilterbar">
        <SkeletonLoader />
      </div>
    );
  };

  const noDataAvailable = () => {
    return (
      <div className="trendingfilterbar" style={{ textAlign: "center" }}>
        <img
          src={require("../../Images/nothing_found.png")}
          style={{ opacity: ".4" }}
        />
        {currentPath.pathname.includes("/answered") && (
          <>
            <p style={{ fontSize: "24px", fontWeight: "bold", opacity: ".7" }}>
              No Answered Questions
            </p>
            <p style={{ fontSize: "20px", fontWeight: "bold", opacity: ".7" }}>
              All answered questions will be here for your review.
            </p>
          </>
        )}
        {currentPath.pathname.includes("/favourite") && (
          <>
            <p style={{ fontSize: "24px", fontWeight: "bold", opacity: ".7" }}>
              No Favorite Questions
            </p>
            <p style={{ fontSize: "20px", fontWeight: "bold", opacity: ".7" }}>
              Questions will be moved to favorite tab after you mark as
              favorite.
            </p>
          </>
        )}
        {currentPath.pathname.includes("/sharedby") && (
          <>
            <p style={{ fontSize: "24px", fontWeight: "bold", opacity: ".7" }}>
              No Shared Questions
            </p>
            <p style={{ fontSize: "20px", fontWeight: "bold", opacity: ".7" }}>
              Questions will be moved to shared tab after you share question to
              someone.
            </p>
          </>
        )}
        {currentPath.pathname.includes("/sharedwith") && (
          <>
            <p style={{ fontSize: "24px", fontWeight: "bold", opacity: ".7" }}>
              No Shared Questions
            </p>
            <p style={{ fontSize: "20px", fontWeight: "bold", opacity: ".7" }}>
              Questions will be moved to shared tab once another user shared
              question with you.
            </p>
          </>
        )}
      </div>
    );
  };

  const renderQApair = (data) => {
    return (
      <InfiniteScroller
        isLoading={pageState.isLoading}
        dataLength={data.length}
        nextFunc={() => fetchMore()}
        cssClassName={"trendingQA"}
        hasMore={true}
      >
        {data.map((qa, index) => {
          return <QuestionBox key={index} data={qa} />;
        })}
      </InfiniteScroller>
    );
  };

  const fetchData = () => {
    if (name === "answeredQuestions") {
      if (
        tabsearchQuery.length === 0 &&
        !isCheckRelevance(pageState.sortOptions) &&
        !recommendState
      ) {
        IsLoadingAnsweredtab(true);
        getTrendingData(
          pageState.pageNo,
          pageState.sortFilter.origValue,
          pageState.sortFilter.sortOrder !== undefined ?pageState.sortFilter.sortOrder:pageState.sortOrder,
          pageState.sortChange,
          pageState.domains,
          "answered",
          CURRENT_ROLE ==="Expert"?pageState.curationCategory: null,
          CURRENT_ROLE ==="Expert"? pageState.isTransferred:null,
          CURRENT_ROLE ==="Expert"? pageState.curationStatus:null
        )
          .then((res) => {
            if (res===undefined) return;
            if (res.data.success) {
              IsLoadingAnsweredtab(false);
              updateAnsweredTabData({
                data: res.data.data,
                count: res.data.count,
              });
            }
          })
          .catch((err) => {
            handleError(err);
          });
      }
      if (
        tabsearchQuery.length !== 0 &&
        isCheckRelevance(pageState.sortOptions) &&
        !recommendState
      ) {
        IsLoadingAnsweredtab(true);
        getTabSearchData(
          pageState.pageNo,
          "answered",
          pageState.sortFilter.origValue,
          tabsearchQuery,
          pageState.sortFilter.sortOrder !== undefined ?pageState.sortFilter.sortOrder:pageState.sortOrder,
          pageState.sortChange,
          pageState.domains,
          null,
          CURRENT_ROLE ==="Expert"?pageState.curationCategory: null,
          CURRENT_ROLE ==="Expert"? pageState.isTransferred:null,
          CURRENT_ROLE ==="Expert"? pageState.curationStatus:null
        ).then((res) => {
          if (res===undefined) return;
          if (res !== undefined && res.data.success) {
            IsLoadingAnsweredtab(false);
            updateAnsweredTabData({
              data: res.data.data,
              count: res.data.count,
            });
          }
        });
      }
    } else {
      if (
        tabsearchQuery.length === 0 &&
        !isCheckRelevance(pageState.sortOptions) &&
        !recommendState
      ) {
        let status;
        let category;
        if (currentPath.pathname.includes("/favourite")) {
          IsLoadingFavouritetab(true);
          status = "getfavourite";
          category = 1;
        }
        if (currentPath.pathname.includes("/sharedby")) {
          IsLoadingSharedBytab(true);
          status = "getsharedbyme";
          category = 2;
        }
        if (currentPath.pathname.includes("/sharedwith")) {
          IsLoadingSharedWithtab(true);
          status = "getsharedwithme";
          category = 2;
        }
        getFavouriteData(
          pageState.pageNo,
          pageState.sortFilter.origValue,
          pageState.sortFilter.sortOrder,
          pageState.sortChange,
          pageState.domains,
          category,
          status
        )
          .then((res) => {
            if (res===undefined) return;
            if (res.data.success) {
              if (currentPath.pathname.includes("/favourite")) {
                IsLoadingFavouritetab(false);
                updateFavouriteTabData({
                  data: res.data.data,
                  count: res.data.count,
                });
              }
              if (currentPath.pathname.includes("/sharedby")) {
                IsLoadingSharedBytab(false);
                updateSharedByTabData({
                  data: res.data.data,
                  count: res.data.count,
                });
              }
              if (currentPath.pathname.includes("/sharedwith")) {
                IsLoadingSharedWithtab(false);
                updateSharedWithTabData({
                  data: res.data.data,
                  count: res.data.count,
                });
              }
            }
          })
          .catch((err) => {
            handleError(err);
          });
      }
      if (
        tabsearchQuery.length !== 0 &&
        isCheckRelevance(pageState.sortOptions) &&
        !recommendState
      ) {
        let status;
        let category;
        if (currentPath.pathname.includes("/favourite")) {
          IsLoadingFavouritetab(true);
          status = "favorite";
          category = 1;
        }
        if (currentPath.pathname.includes("/sharedby")) {
          IsLoadingSharedBytab(true);
          status = "sharedByMe";
          category = 2;
        }
        if (currentPath.pathname.includes("/sharedwith")) {
          IsLoadingSharedWithtab(true);
          status = "sharedWithMe";
          category = 2;
        }
        getTabSearchData(
          pageState.pageNo,
          status,
          pageState.sortFilter.origValue,
          tabsearchQuery,
          pageState.sortFilter.sortOrder,
          pageState.sortChange,
          pageState.domains,
          category
        )
          .then((res) => {
            if (res===undefined) return;
            if (res.data.success) {
              if (currentPath.pathname.includes("/favourite")) {
                IsLoadingFavouritetab(false);
                updateFavouriteTabData({
                  data: res.data.data,
                  count: res.data.count,
                });
              }
              if (currentPath.pathname.includes("/sharedby")) {
                IsLoadingSharedBytab(false);
                updateSharedByTabData({
                  data: res.data.data,
                  count: res.data.count,
                });
              }
              if (currentPath.pathname.includes("/sharedwith")) {
                IsLoadingSharedWithtab(false);
                updateSharedWithTabData({
                  data: res.data.data,
                  count: res.data.count,
                });
              }
            }
          })
          .catch((err) => {
            handleError(err);
          });
      }
    }
  };

  const fetchMore = () => {
    if (currentPath.pathname.includes("/answered")) {
      let totalCount = pageState.totalCount;
      let currentDataCount = pageState.data.length;
      let upcomingPage = pageState.pageNo + 1;
      if (currentDataCount < totalCount) {
        setTimeout(() => {
          updatePageNoAnswered(upcomingPage);
        }, 500);
      }
    }
    if (currentPath.pathname.includes("/favourite")) {
      let totalCount = pageState.totalCount;
      let currentDataCount = pageState.data.length;
      let upcomingPage = pageState.pageNo + 1;
      if (currentDataCount < totalCount) {
        setTimeout(() => {
          updatePageNoFavourite(upcomingPage);
        }, 500);
      }
    }
    if (currentPath.pathname.includes("/sharedby")) {
      let totalCount = pageState.totalCount;
      let currentDataCount = pageState.data.length;
      let upcomingPage = pageState.pageNo + 1;
      if (currentDataCount < totalCount) {
        setTimeout(() => {
          updatePageNoSharedBy(upcomingPage);
        }, 500);
      }
    }
    if (currentPath.pathname.includes("/sharedwith")) {
      let totalCount = pageState.totalCount;
      let currentDataCount = pageState.data.length;
      let upcomingPage = pageState.pageNo + 1;
      if (currentDataCount < totalCount) {
        setTimeout(() => {
          updatePageNoSharedWith(upcomingPage);
        }, 500);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pageState.domains,
    pageState.sortFilter,
    tabsearchQuery,
    pageState.pageNo,
    pageState.reload,
    pageState.sortOrder,
    pageState.curationStatus
  ]);
  return (
    <>
      <div>
        <MiniDrawer>
          {searchBar()}
          {filterTab()}
          {pageState.isLoading && pageState.pageNo === 0 && Loader()}
          {pageState.data.length > 0 && renderQApair(pageState.data)}
          {!pageState.isLoading &&
            pageState.data.length === 0 &&
            noDataAvailable()}
        </MiniDrawer>
      </div>
    </>
  );
}
